import { LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from 'src/core/core.module';
import { PagesAdminModule } from './pages-admin/pages-admin.module';
import { PagesClientModule } from './pages-client/pages-client.module';
import { SharedModule } from './shared/shared.module';
import { PublicPagesModule } from './public-pages/public-pages.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import  localeEs  from '@angular/common/locales/es';
import { EpaycoPaymentComponent } from './epayco-payment/epayco-payment.component';
import { ServiceWorkerModule } from '@angular/service-worker';

registerLocaleData(localeEs, 'es')

@NgModule({
  declarations: [
    AppComponent,
    EpaycoPaymentComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    PagesAdminModule,
    PagesClientModule,
    PublicPagesModule,
    SharedModule,
    BrowserAnimationsModule,
    // Registrar SW custom que no intercepta SSE/API
    ServiceWorkerModule.register('sw-master.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),

  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'es'
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
